import request from '@/utils/request';

// 采购开单
export function purchaseOrderCreate(data) {
  return request({ url: `/purchaseOrders/`, method: 'post', data })
}

// 采购记录
export function purchaseOrderList(params) {
  return request({ url: `/purchaseOrders/`, method: 'get', params })
}

// 采购记录详情
export function purchaseOrderDetail(params) {
  return request({ url: `/purchaseOrders/${params.id}/`, method: 'get', params })
}

// 采购记录作废
export function purchaseOrdersVoid(data) {
  return request({ url: `/purchaseOrders/${data.id}/void/`, method: 'post', data })
}

// 采购退货单
export function purchaseReturnOrderCreate(data) {
  return request({ url: `/purchaseReturnOrders/`, method: 'post', data })
}

// 退货记录
export function purchaseReturnOrdersList(params) {
  return request({ url: `/purchaseReturnOrders/`, method: 'get', params })
}

// 退货记录详情
export function purchaseReturnOrderDetail(params) {
  return request({ url: `/purchaseReturnOrders/${params.id}/`, method: 'get', params })
}

// 退货记录作废
export function purchaseReturnOrdersVoid(data) {
  return request({ url: `/purchaseReturnOrders/${data.id}/void/`, method: 'post', data })
}

